import { 
  Box, 
  Card, 
  MenuItem, 
  Select, 
  IconButton, 
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  useTheme
} from '@mui/material'
import SettingsIcon from '@mui/icons-material/Settings'

import { useEffect, useState } from 'react'
import WTypography from 'Components/whiteTypography'
import Avatar from '@mui/material/Avatar'
import { makeGetRequest } from 'utils/api'
import moment from 'moment'
import { convertToMuiDate } from 'utils/helpers'
import { makePostRequest } from 'utils/api'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
// import 'moment/locale/fr'

function MonPortrait({ oldData, updateReports }) {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const theme = useTheme()
  const [user, setUser] = useState({})
  const [mStatus, setMStatus] = useState(0)
  const [modalOpen, setModalOpen] = useState(false)
  const [editData, setEditData] = useState({
    nom: '',
    prenom: '',
    vile: '',
    marital_status: 0,
    nombre_enfants: 0
  })

  const handleChange = (event) => {
    setMStatus(event.target.value)
    let payload = {
      ...user,
      date_de_naissance: convertToMuiDate(user.date_de_naissance),
      marital_status: event.target.value,
    }
    delete payload.img_url
    delete payload.age
    makePostRequest('/api/user/update-profile/', payload, {}, true)
  }

  useEffect(() => {
    fetchUser()
  }, [])
  const fetchUser = async () => {
    const response = await makeGetRequest('/api/user/user/', {}, true)

    if (response.status === 200) {
      let age = calculateAge(convertToMuiDate(response.data.date_de_naissance))
      let user_data = { ...response.data, age: age }
      setMStatus(response.data.marital_status)
      setUser(user_data)
      setEditData({
        nom: response.data.nom || '',
        prenom: response.data.prenom || '',
        vile: response.data.vile || '',
        marital_status: response.data.marital_status || 0,
        nombre_enfants: response.data.nombre_enfants || 0
      })
    }
  }

  const handleOpenModal = (e) => {
    e.stopPropagation() // Prevent card drag
    setEditData({
      nom: user.nom || '',
      prenom: user.prenom || '',
      vile: user.vile || '',
      marital_status: user.marital_status || 0,
      nombre_enfants: user.nombre_enfants || 0
    })
    setModalOpen(true)
  }

  const handleCloseModal = () => {
    setModalOpen(false)
  }

  const handleSaveModal = async () => {
    try {
      let payload = {
        ...user,
        nom: editData.nom,
        prenom: editData.prenom,
        vile: editData.vile,
        date_de_naissance: convertToMuiDate(user.date_de_naissance),
        marital_status: editData.marital_status,
        nombre_enfants: parseInt(editData.nombre_enfants) || 0,
      }
      delete payload.img_url
      delete payload.age

      const response = await makePostRequest('/api/user/update-profile/', payload, {}, true)
      
      if (response.status === 200) {
        setMStatus(editData.marital_status)
        setUser({
          ...user,
          nom: editData.nom,
          prenom: editData.prenom,
          vile: editData.vile,
          marital_status: editData.marital_status,
          nombre_enfants: editData.nombre_enfants
        })
        setModalOpen(false)
        if (updateReports) {
          updateReports()
        }
      }
    } catch (error) {
      console.error('Error saving profile:', error)
      alert(t('monPatrimoine.saveError')) // LAP-733 (GE022)
    }
  }
  function calculateAge(birthDate) {
    const today = new Date()
    const birthDateObj = new Date(birthDate)

    let age = today.getFullYear() - birthDateObj.getFullYear()
    const monthDifference = today.getMonth() - birthDateObj.getMonth()
    const dayDifference = today.getDate() - birthDateObj.getDate()

    // If the birth month is greater than the current month or it's the current month but birth day hasn't occurred yet
    if (monthDifference < 0 || (monthDifference === 0 && dayDifference < 0)) {
      age--
    }

    return age
  }
  return (
    <>
      <Card className="dashboard_card__root1">
        <Box className="dashboard_card__header1" display="flex" justifyContent="space-between" alignItems="center">
          <WTypography component={'span'} variant="h6">
            {t('monPatrimoine.monPortraitTitle')}
          </WTypography>
          <IconButton
            onClick={handleOpenModal}
            onMouseDown={(e) => e.stopPropagation()}
            onTouchStart={(e) => e.stopPropagation()}
            sx={{ color: 'white' }}
            size="small"
            className="no-drag"
          >
            <SettingsIcon />
          </IconButton>
        </Box>
        <Box className="dashboard_card__header1">
          <Avatar
            sx={{ height: 110, width: 110, mt: 1 }}
            alt="Alexis"
            src={user.img_url || 'https://cdn-icons-png.flaticon.com/512/147/147140.png'}
          />
        </Box>

        <Box minWidth={3} mb={6} height={'100%'}>
          <WTypography component={'div'} variant="h6">
            {user.prenom} {user.nom}
          </WTypography>
          <WTypography sx={{ color: 'gray' }} component={'div'}>
            {t('monPatrimoine.ages')}
          </WTypography>
          <WTypography component={'div'} variant="h6">
            {user.age} {t('monPatrimoine.yearsSuffix')}
          </WTypography>
          <WTypography sx={{ color: 'gray' }} component={'div'}>
            {t('monPatrimoine.familyStatus')}
          </WTypography>
          <WTypography component={'div'} variant="h6" className="no-drag">
            <Select
              value={mStatus}
              sx={{
                color: 'white',
                border: 'none',
                '.MuiSelect-select': { padding: '10px 5px', fontSize: 'larger' },
                fieldset: { borderColor: 'unset', border: 0 },
                '.MuiSelect-select.Mui-focused': { borderColor: 'unset', border: 0 },
                '.MuiOutlinedInput-notchedOutline': { borderColor: 'unset', border: 0 },
              }}
              onChange={handleChange}
              fullWidth
              className="no-drag"
            >
              <MenuItem value={0}>{t('monPatrimoine.single')}</MenuItem>
              <MenuItem value={'Concubin'}>{t('monPatrimoine.concubin')}</MenuItem>
              <MenuItem value={'Pacsée'}>{t('monPatrimoine.pacs')}</MenuItem>
              <MenuItem value={'mariée'}>{t('monPatrimoine.married')}</MenuItem>
              <MenuItem value={'veuve'}>{t('monPatrimoine.widowed')}</MenuItem>
              <MenuItem value={'divorcée'}>{t('monPatrimoine.divorced')}</MenuItem>
            </Select>
          </WTypography>
          <WTypography sx={{ color: 'gray' }} component={'div'}>
            {t('monPatrimoine.children')}
          </WTypography>
          <WTypography component={'div'} variant="h6">
            {user.nombre_enfants || 0}
          </WTypography>
          <WTypography sx={{ color: 'gray' }} component={'div'}>
            {t('monPatrimoine.cityOfResidence')}
          </WTypography>
          <WTypography component={'div'} variant="h6">
            {user.vile}
          </WTypography>
        </Box>
      </Card>

      {/* Settings Modal */}
      <Dialog open={modalOpen} onClose={handleCloseModal} maxWidth="sm" fullWidth>
        <DialogTitle>
          {t('monPatrimoine.editPortrait')}
        </DialogTitle>
        <DialogContent>
          <Box mt={2}>
            {/* Editable: First Name */}
            <TextField
              label={t('monPatrimoine.firstName')}
              value={editData.prenom}
              onChange={(e) => setEditData({...editData, prenom: e.target.value})}
              fullWidth
              margin="normal"
            />

            {/* Editable: Last Name */}
            <TextField
              label={t('monPatrimoine.lastName')}
              value={editData.nom}
              onChange={(e) => setEditData({...editData, nom: e.target.value})}
              fullWidth
              margin="normal"
            />

            {/* Read-only: Age */}
            <TextField
              label={t('monPatrimoine.age')}
              value={`${user.age || 0} ${t('monPatrimoine.yearsSuffix')}`}
              fullWidth
              margin="normal"
              InputProps={{ readOnly: true }}
              disabled
            />

            {/* Editable: Family Status */}
            <FormControl fullWidth margin="normal">
              <InputLabel>{t('monPatrimoine.familyStatusLabel')}</InputLabel>
              <Select
                value={editData.marital_status}
                label={t('monPatrimoine.familyStatusLabel')}
                onChange={(e) => setEditData({...editData, marital_status: e.target.value})}
              >
                <MenuItem value={0}>{t('monPatrimoine.single')}</MenuItem>
                <MenuItem value={'Concubin'}>{t('monPatrimoine.concubin')}</MenuItem>
                <MenuItem value={'Pacsée'}>{t('monPatrimoine.pacs')}</MenuItem>
                <MenuItem value={'mariée'}>{t('monPatrimoine.married')}</MenuItem>
                <MenuItem value={'veuve'}>{t('monPatrimoine.widowed')}</MenuItem>
                <MenuItem value={'divorcée'}>{t('monPatrimoine.divorced')}</MenuItem>
              </Select>
            </FormControl>

            {/* Editable: Number of children */}
            <TextField
              label={t('monPatrimoine.numberOfChildren')}
              type="number"
              value={editData.nombre_enfants}
              onChange={(e) => setEditData({...editData, nombre_enfants: e.target.value})}
              fullWidth
              margin="normal"
              inputProps={{ min: 0 }}
            />

            {/* Editable: City */}
            <TextField
              label={t('monPatrimoine.cityOfResidenceLabel')}
              value={editData.vile}
              onChange={(e) => setEditData({...editData, vile: e.target.value})}
              fullWidth
              margin="normal"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal}>
            {t('monPatrimoine.cancel')}
          </Button>
          <Button onClick={handleSaveModal} variant="contained" color="primary">
            {t('monPatrimoine.save')}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default MonPortrait
